import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {isGM, isAdmin} from '../../../utils/auth';

import * as diamondActionCreators from '../../../actions/diamonds';
let allActionCreators = Object.assign({}, diamondActionCreators);

class DiamondSourceBanner extends React.Component {

  getBannerCopy() {
  	if(!this.props.diamonds || !this.props.diamonds.source) {
  		return '';
  	}

  	switch(this.props.diamonds.source) {
  		case 'online':
  			return 'Online Diamonds';
  		case 'rapnet':
  			return 'Rapnet Diamonds';
  		case 'lab':
  			return 'LGD';
  		default:
  			return 'In-Store Diamonds';
  	}
  }

  isTabSelected(tabCode) {
  	if(!tabCode) {
  		return false;
  	}

  	const exactMatches = [
  		'online',
  		'rapnet',
  		'lab',
  		'store',
  	];

  	if(exactMatches.includes(tabCode)) {
  		return this.props.diamonds.source === tabCode;
  	} else {
  		return true;
  	}
  }

  selectTab(tabCode) {
  	if(!tabCode) {
  		return null;
  	}

  	if(this.isTabSelected(tabCode)) {
  		return null;
  	}

  	this.props.setDiamondSource(tabCode);
  }

  shouldShowRapnet() {
  	return isGM() || isAdmin();
  }

  shouldShowLab() {
  	return true;
  }

	render() {
		return <div className='DiamondSourceBanner'>
			<div className={`sourceSpacer ${this.props.showTabs ? 'withTabs' : ''}`}></div>
			<div className='sourceElement'>
				<div className={`dsbBanner ${this.props.diamonds.source}`}>{this.getBannerCopy()}</div>
				{this.props.showTabs ?
					<div className={this.shouldShowRapnet() ? 'dsbTabs' : 'dsbTabs twoTabs'}>
						<div className='dsbTabWrapper'>
							<div 
								className={this.isTabSelected('store') ? 'dsbTab first selected' : 'dsbTab first'}
								onClick={() => this.selectTab('store')}>
								In-Store
							</div>
						</div>
						<div className='dsbTabWrapper' style={{display: 'none'}}>
							<div 
								className={this.isTabSelected('online') ? 'dsbTab selected' : 'dsbTab'}
								onClick={() => this.selectTab('online')}>
								ONLINE
							</div>
						</div>
						{this.shouldShowRapnet() ?
							<div className='dsbTabWrapper'>
								<div 
									className={this.isTabSelected('rapnet') ? 'dsbTab selected' : 'dsbTab'}
									onClick={() => this.selectTab('rapnet')}>
									Rapnet
								</div>
							</div> :
							null
						}
						{this.shouldShowLab() ?
							<div className='dsbTabWrapper'>
								<div 
									className={this.isTabSelected('lab') ? 'dsbTab selected' : 'dsbTab'}
									onClick={() => this.selectTab('lab')}>
									LGD
								</div>
							</div> :
							null
						}
					</div> :
					null
				}
			</div>
		</div>;
	}
}
export default DiamondSourceBanner;

function mapStateToProps(state) {
	return {
		diamonds: state.diamonds,
	};
}

export const DiamondSourceBannerContainer = connect(
	mapStateToProps,
	allActionCreators
)(DiamondSourceBanner);